import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const Support = lazy(() => import('./Support'));

const SupportConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/support',
      element: <Support />,
    },
  ],
};

export default SupportConfig;
